import React, { Component } from "react";
import { Link } from "react-router-dom";
import cx from "classnames";
import jwt from "../../utils/jwt";
import "./sideMenu.scss";
import mixpanel from "mixpanel-browser";
import {operatorType, mixPanelToken, isStage, businessModelType} from "../../config";
class SideMenu extends Component {
  state = {
    active: 0,
    logout: false,
    isBillingOpen: false,
  };
  async componentDidMount() {
    const token = localStorage.getItem("idToken");
    const decodedToken = jwt.decode(token);
    const userMobileNo = decodedToken.mobileNo;
    let userName = decodedToken.name || decodedToken.mgName;
    let userType = decodedToken.userType || "OPERATOR";

    if (sessionStorage.getItem("userType")) {
      userType = sessionStorage.getItem("userType");
    } else if (decodedToken && decodedToken.isElectricUser) {
      userName = decodedToken.electricName;
      userType = "ELECTRIC";
    }
    this.setState({
      userMobileNo: userMobileNo,
      userName: userName,
      userType: userType,
    });
  }
  setIsBillingOpen = () => {
    this.setState({ isBillingOpen: !this.state.isBillingOpen });
  };

  hideSideBarOnClickMobile = () => {
    const { toggleSideMenu } = this.props;
    if (typeof toggleSideMenu === "function") {
      return toggleSideMenu();
    }
  };

  handleLinkClick = (activeItemIndex) => {
    const { userType } = this.state;

    const business_model_type = businessModelType.find(
      (opt) => opt.value === userType
    )?.label;
    
    const selectedKey = this.props.page;
    let page = "";
    if (selectedKey == 1) {
      page = "Home Page";
    } else if (selectedKey == 2) {
      page = "Inspection Data Page";
    } else if (selectedKey == 3) {
      page = "Feedback Page";
    } else if (selectedKey == 4) {
      page = "Audit Data Page";
    }
    if (activeItemIndex == 1) {
      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track("Home Tab Clicked", {
        mobile_number: this.state.userMobileNo,
        view_from: page,
        type: userType,
        business_model_type,
      });
    } else if (activeItemIndex == 2) {
      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track("Inspection Data Tab Clicked", {
        mobile_number: this.state.userMobileNo,
        view_from: page,
        type: userType,
        business_model_type,
      });
    } else if (activeItemIndex == 5) {
      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track("Feedback Tab Clicked", {
        mobile_number: this.state.userMobileNo,
        view_from: page,
        type: userType,
        business_model_type,
      });
    } else if (activeItemIndex == 4) {
      mixpanel.init(mixPanelToken, { debug: isStage });
      mixpanel.track("Audit Data Tab Clicked", {
        mobile_number: this.state.userMobileNo,
        view_from: page,
        type: userType,
        business_model_type,
      });
    }

    this.setState({ active: activeItemIndex }, this.hideSideBarOnClickMobile);
  };

  deleteToken = () => {
    // window.history.push("login");
    localStorage.removeItem("idToken");
    localStorage.removeItem("consentGivenAt")
    localStorage.removeItem("refreshToken");
  };

  render() {
    const { active, userMobileNo, userName, userType, isBillingOpen } =
      this.state;
    const activeLink = Math.round(this.props.active);
    const activeItem = active || activeLink;
    const activeItemClass = "menuItem active";
    const defaultItemClass = "menuItem";

    const token = localStorage.getItem("idToken");
    const decodedToken = jwt.decode(token);

    return (
      <div id="SideNav">
        <div className="menu">
          <Link
            to="/profile"
            onClick={() => this.handleLinkClick(3)}
            style={{ textDecoration: "none" }}
          >
            <div
              className={cx(
                activeItem === 3 ? activeItemClass : defaultItemClass
              )}
              style={{ marginTop: "-30px" }}
            >
              <div className="menuContent">
                <span className="menuIcon">
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/profile.svg"
                    alt="profile icon"
                  />
                </span>
                <div
                  className="menuItemFont"
                  style={{ marginLeft: "25px", marginTop: "25px" }}
                >
                  <div style={{ textAlign: "left" }}>
                    <span>{userName ? `Hi ${userName}` : `Hi Operator`}</span>
                  </div>
                  <div style={{ marginTop: "10px", textAlign: "left" }}>
                    <span style={{ color: "#7D7D7D" }}>{userMobileNo}</span>
                  </div>
                </div>
              </div>
              <img
                className="rightArrow"
                style={{ marginTop: "20px" }}
                src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
              />
            </div>
          </Link>

          <Link
            to="/"
            onClick={() => this.handleLinkClick(1)}
            style={{ textDecoration: "none" }}
          >
            <div
              className={cx(
                activeItem === 1 ? activeItemClass : defaultItemClass
              )}
            >
              <div className="menuContent">
                <span className="menuIcon">
                  <img
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/home-outline1.svg"
                    alt="menu icon"
                  />
                </span>
                <div className="menuItemFont">Home</div>
              </div>
              <img
                className="rightArrow"
                src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
              />
            </div>
          </Link>

          {userType && userType === operatorType.CABOWNER ? (
            <>
              <Link
                to="/trips"
                onClick={() => this.handleLinkClick(6)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 6 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/opdash/sidemenu/car-outline.svg"
                        alt="menu icon"
                      />
                    </span>
                    <div className="menuItemFont">Trips</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>
              <Link
                to="/fmlmPaymentSummary"
                onClick={() => this.handleLinkClick(6)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 4 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/rupee/ruppeblack.svg"
                        alt="menu icon"
                      />
                    </span>
                    <div className="menuItemFont">Payment Summary</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>
              <Link
                to="/cabKYC"
                onClick={() => this.handleLinkClick(7)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 7 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/rupee/ruppeblack.svg"
                        alt="menu icon"
                      />
                    </span>
                    <div className="menuItemFont">KYC</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>
              <div
                onClick={this.setIsBillingOpen}
                className={cx(
                  activeItem === 8 ? activeItemClass : defaultItemClass,
                  "menuItem"
                )}
                style={{ cursor: "pointer" }}
              >
                <div className="menuContent">
                  <span className="menuIcon">
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/rupee/ruppeblack.svg"
                      alt="menu icon"
                    />
                  </span>
                  <div className="menuItemFont">Billing</div>
                </div>
                <img
                  className="rightArrow"
                  src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  style={{
                    transform: this.state.isBillingOpen
                      ? "rotate(180deg)"
                      : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                  }}
                />
              </div>

              {/* Dropdown content */}
              {this.state.isBillingOpen && (
                <div className="submenu">
                  <Link
                    to="/createInvoice"
                    onClick={() => this.handleLinkClick(81)}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      className={cx(
                        activeItem === 81 ? activeItemClass : defaultItemClass,
                        "submenuItem"
                      )}
                    >
                      <div className="menuContent">
                        <div className="menuItemFont">Create Invoice</div>
                      </div>
                    </div>
                  </Link>

                  <Link
                    to="/submittedInvoices"
                    onClick={() => this.handleLinkClick(82)}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      className={cx(
                        activeItem === 82 ? activeItemClass : defaultItemClass,
                        "submenuItem"
                      )}
                    >
                      <div className="menuContent">
                        <div className="menuItemFont">Submitted Invoice</div>
                      </div>
                    </div>
                  </Link>
                </div>
              )}
            </>
          ) :  userType === operatorType.BUSOWNER ? (
            <>
              <Link
                to="/inspectionDataDetails"
                onClick={() => this.handleLinkClick(2)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 2 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/opdash/sidemenu/clipboard-outline2.svg"
                        alt="menu icon"
                      />
                    </span>
                    <div className="menuItemFont">Inspection Data</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>

              <Link
                to="/auditDataDetails"
                onClick={() => this.handleLinkClick(4)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 4 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/sidemenu/analytics-outline2.svg"
                        alt="menu icon"
                      />
                    </span>
                    <div className="menuItemFont">Audit Data</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>

              <Link
                to="/FeedbackDetails"
                onClick={() => this.handleLinkClick(5)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 5 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/opdash/sidemenu/chaticon.svg"
                        alt="menu icon"
                      />
                    </span>
                    <div className="menuItemFont">Feedback</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>

               <Link
                to="/resources"
                onClick={() => this.handleLinkClick(7)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 7 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/resources.svg"
                        alt="resources"
                      />
                    </span>
                    <div className="menuItemFont">Resources</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>
            </>
          ) : userType === "ELECTRIC"  ? (
            <>
              <Link
                to="/wallet"
                onClick={() => this.handleLinkClick(6)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 7 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/wallet.svg"
                        alt="menu icon"
                      />
                    </span>
                    <div className="menuItemFont">Wallet</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>
            </>
          ) : (
            <>
              <Link
                to="/operatorDealsDetails"
                onClick={() => this.handleLinkClick(2)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 2 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/opdash/sidemenu/clipboard-outline2.svg"
                        alt="menu icon"
                      />
                    </span>
                    <div className="menuItemFont">Operator Deals</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>

              <Link
                to="/offlineCommission"
                onClick={() => this.handleLinkClick(4)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 4 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/optdash/sidemenu/analytics-outline2.svg"
                        alt="menu icon"
                      />
                    </span>
                    <div className="menuItemFont">Offline Commission</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>
              <Link
                to="/seatFare"
                onClick={() => this.handleLinkClick(5)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 5 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/opdash/sidemenu/chaticon.svg"
                        alt="menu icon"
                      />
                    </span>
                    <div className="menuItemFont">Offline Seat Fare</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>
              <Link
                to="/payouts"
                onClick={() => this.handleLinkClick(5)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 5 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/payout.svg"
                        alt="menu icon"
                      />
                    </span>
                    <div className="menuItemFont">Payouts</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>
              <Link
                to="/kyc"
                onClick={() => this.handleLinkClick(6)}
                style={{ textDecoration: "none" }}
              >
                <div
                  className={cx(
                    activeItem === 6 ? activeItemClass : defaultItemClass
                  )}
                >
                  <div className="menuContent">
                    <span className="menuIcon">
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/operator/kyc.svg"
                        alt="menu icon"
                      />
                    </span>
                    <div className="menuItemFont">KYC</div>
                  </div>
                  <img
                    className="rightArrow"
                    src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                  />
                </div>
              </Link>
              {/* <div
                onClick={() => this.setIsBillingOpen(!isBillingOpen)}
                className="menuItem"
              >
                <div className="menuContent">
                  <span className="menuIcon">
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/opdash/sidemenu/chaticon.svg"
                      alt="menu icon"
                    />
                  </span>
                  <div className="menuItemFont">Billing</div>
                </div>
              </div>
              {isBillingOpen && (
                <div className="submenu">
                  <Link
                    to="/createInvoice"
                    onClick={() => this.handleLinkClick(71)}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      className={cx(
                        activeItem === 71 ? activeItemClass : defaultItemClass
                      )}
                    >
                      <div className="menuContent">
                        <span className="menuIcon"></span>
                        <div className="menuItemFont">Create Invoice</div>
                      </div>
                      <img
                        className="rightArrow"
                        src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                      />
                    </div>
                  </Link>
                  <Link
                    to="/submittedInvoices"
                    onClick={() => this.handleLinkClick(71)}
                    style={{ textDecoration: "none" }}
                  >
                    <div
                      className={cx(
                        activeItem === 71 ? activeItemClass : defaultItemClass
                      )}
                    >
                      <div className="menuContent">
                        <span className="menuIcon"></span>
                        <div className="menuItemFont">Submitted Invoice</div>
                      </div>
                      <img
                        className="rightArrow"
                        src="https://d1flzashw70bti.cloudfront.net/original/images/opdas/sidemenu/rightangle.svg"
                      />
                    </div>
                  </Link>
                </div>
              )} */}
            </>
          )}
        </div>

        <Link to="/login" className="menuItemFont" onClick={this.deleteToken}>
          <button
            className="confirmButton"
            style={{
              width: "93%",
              backgroundColor: "#ee6f6d",
              fontStyle: "bold",
              fontWeight: "700",
              border: "none",
              borderRadius: "8px",
            }}
          >
            <span className="text">Logout</span>
          </button>
        </Link>
      </div>
    );
  }
}

export default SideMenu;
